/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default () =>
(
  <svg width = '18' height = '18' viewBox = '0 0 18 18' fill = 'none' stroke = 'currentColor' strokeLinecap = 'round' xmlns = 'http://www.w3.org/2000/svg'>
    <circle cx = '9' cy = '9' r = '8' />
    <path d = 'M3 7.2 C4.6 6.4 6.4 6.6 7.6 7.4 C8.8 8.2 10.4 8 11.6 7.4 M5 10.6 C6.6 9.8 8.6 10.2 9.8 11 C11 11.8 12.8 11.6 14 10.8 M11.4 5.4 C12.4 5 13.4 5.2 14 5.8' />
  </svg>
);
